import React, { Fragment, useEffect, useState } from 'react';
import { ShieldIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/oysDNYFC2wwFpxCgBqonwH/ChatGPT-Image-19-jul-2026_-04_20_54-p.m..webp';
const CHECKOUT_URL = 'https://kine-ready.impultienda.ar/checkout';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 45,
    seconds: 30
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(previous => {
        let {
          hours,
          minutes,
          seconds
        } = previous;
        if (seconds > 0) seconds -= 1;else if (minutes > 0) {
          minutes -= 1;
          seconds = 59;
        } else if (hours > 0) {
          hours -= 1;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 45;
          seconds = 30;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units = [{
    value: timeLeft.hours,
    label: 'HEURES'
  }, {
    value: timeLeft.minutes,
    label: 'MINUTES'
  }, {
    value: timeLeft.seconds,
    label: 'SECONDES'
  }];
  return <section id="pricing" className="scroll-mt-2 border-y-4 border-brand-gold/50 bg-brand-ivory px-4 py-5 sm:px-6" data-id="element-115" data-mp="37i3zvn1b5odf">
      <div className="mb-3 text-center" data-id="element-116" data-mp="2stzo730oad45">
        <p className="mb-1 text-sm font-extrabold uppercase tracking-widest text-brand-gold" data-id="element-117" data-mp="2xtcbtpzdbo7s">OFFRE SPÉCIALE — SYSTÈME COMPLET 6-EN-1</p>
        <p className="mx-auto mb-2 max-w-md text-sm font-bold leading-snug text-brand-navy" data-id="element-118" data-mp="2jstaf1pergel">Accédez dès aujourd'hui au système qui transformera votre façon de préparer vos consultations.</p>
        <div className="mb-2 inline-block rounded-sm bg-brand-navy px-3 py-2 text-white shadow-sm" data-id="element-119" data-mp="29wq6bqazx7p0">
          <p className="text-sm font-bold" data-id="element-120" data-mp="2evt18hx9hxj9">🩺 KINÉ READY™</p>
          <p className="mt-0.5 text-xs font-bold leading-snug" data-id="element-121" data-mp="84abownfz3em">Le Système Complet de Planification 6-en-1 pour les Kinésithérapeutes</p>
          <p className="mt-1 text-xs font-bold" data-id="element-122" data-mp="d2bv5ios54qm">✅ 6 Modules Professionnels</p>
          <p className="text-xs font-bold" data-id="element-123" data-mp="bmr0j0hmlas3">✅ 5 Bonus Premium</p>
        </div>
        <a href="#pricing" className="block cursor-pointer" aria-label="Voir l'offre KINÉ READY" data-id="element-124" data-mp="bjv5bjx5x07c">
          <img src={PRODUCT_IMG} alt="Coffret numérique KINÉ READY, système complet 6 en 1 pour kinésithérapeutes" className="mx-auto mb-2 w-full max-w-[240px] object-contain drop-shadow-xl transition-transform hover:scale-[1.02]" data-id="element-125" data-mp="6phbvn22935b" />
        </a>
      </div>
      <div className="mb-2 rounded-lg border-4 border-brand-gold bg-white p-3 text-center shadow-xl" data-id="element-126" data-mp="ube5lizsy05o">
        <div className="mb-3" data-id="element-127" data-mp="pexjsvg2rxvr">
          <p className="mb-1 text-sm font-bold text-brand-muted" data-id="element-128" data-mp="pfys4s5pi69s">Prix habituel : <span className="line-through" data-id="element-129" data-mp="klcqvhtc9u3f">97 €</span></p>
          <p className="mb-1 text-sm font-extrabold uppercase tracking-wide text-red-600" data-id="element-130" data-mp="glkib53y3ny2">🔥 OFFRE DE LANCEMENT — 72 % DE RÉDUCTION</p>
          <p className="text-sm font-bold uppercase text-brand-navy" data-id="element-131" data-mp="1d406withaixn">Aujourd'hui seulement :</p>
          <p className="text-6xl font-black leading-none text-brand-navy" data-id="element-132" data-mp="18bowun50xgrd">27 €</p>
          <p className="mt-1 text-xs font-bold uppercase tracking-wide text-brand-muted" data-id="element-133" data-mp="2r0078yr5vco4">Payez en toute sécurité dans votre devise locale.</p>
        </div>
        <div className="mb-3 rounded-md border border-red-200 bg-red-50 p-2.5" data-id="element-134" data-mp="2w062sq0jxjbh">
          <p className="mb-2 text-sm font-bold leading-tight text-red-600" data-id="element-135" data-mp="2zyljkc61hvgg">🔥 Cette offre disparaîtra lorsque le compteur atteindra zéro.</p>
          <div className="flex justify-center gap-2" data-id="element-136" data-mp="39ycegeyiich2">
            {units.map((unit, index) => <Fragment key={unit.label} data-id="element-137" data-mp="3ewxjqssmfmcd" data-mpi={index}>
                {index > 0 && <div className="mt-1 text-lg font-bold text-brand-navy" data-id="element-138" data-mp="3evco0zuklxcx">:</div>}
                <div className="text-center" data-id="element-139" data-mp="3jp71vmnhvi43">
                  <div className="rounded-sm bg-brand-navy px-2.5 py-1 text-xl font-bold leading-none text-white" data-id="element-140" data-mp="3nphjxxok9yzb">{String(unit.value).padStart(2, '0')}</div>
                  <p className="mt-1 text-[8px] font-bold tracking-wider text-brand-text" data-id="element-141" data-mp="3sq59sg1209ry">{unit.label}</p>
                </div>
              </Fragment>)}
          </div>
        </div>
        <CTAButton href={CHECKOUT_URL} data-id="element-142" data-mp="3jzn6goidxhke">🚀 OUI ! JE VEUX MON SYSTÈME COMPLET 6-EN-1</CTAButton>
      </div>
      <div className="flex flex-col items-center justify-center gap-1 text-[11px] font-bold text-brand-text sm:flex-row sm:gap-3 sm:text-xs" data-id="element-143" data-mp="3f1by6i7qnf4a">
        <div className="flex items-center gap-1" data-id="element-144" data-mp="3oroefy8ism4m"><StarIcon className="h-4 w-4 fill-brand-gold text-brand-gold" data-id="element-145" data-mp="3osptsewkjus5" />⭐ 4,9/5 — Avis vérifiés de kinésithérapeutes</div>
        <div className="flex items-center gap-1" data-id="element-146" data-mp="312lxytpmgzbp"><ShieldIcon className="h-4 w-4 text-brand-blue" data-id="element-147" data-mp="2w30ss1juzuqj" />🛡️ Garantie satisfait ou remboursé pendant 7 jours — Zéro risque</div>
      </div>
    </section>;
}